import request from '@/utils/request'

// 获取我的消息
export function getMessage(page = 1) {
    return request({
        url: '/agent/messageRecord/find-all',
        method: 'get',
        params: {
            page
        }
    })
}

// 阅读消息
export function readMessageApi(id) {
    return request({
        url: `/agent/messageRecord/read/${id}`,
        method: 'post',
    })
}



// WEBPACK FOOTER //
// ./src/api/message.js